import React from 'react';
import ContainerList from '../../components/Containers/ContainerList';

const ContainersPage: React.FC = () => {
    return (
        <div className="customers-page">
            <ContainerList />
        </div>
    );
};

export default ContainersPage; 